import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { OrganizationLimit } from '../../../../shared/organizations/types';

// We can keep this data around for a bit longer since org limits don't change often.
const STALE_TIME = 1000 * 60 * 5; // 5 minutes

function fetchReleaseGroupLimit(orgId: number) {
  return get<OrganizationLimit>(`/api/organizations/${orgId}/limits/release-groups`);
}

/**
 * This is used by react-query for caching and invalidation.
 * This can contain anything (including objects like filters)
 * that can be used to uniquely identify the query.
 */
const getqueryKey = (orgId: number): QueryKey => ['organizations', orgId, 'limits', 'release-groups'];

/**
 * Fetches the release group limits and usage for the organization.
 */
export default function useReleaseGroupLimit(orgId: number) {
  return useQuery<OrganizationLimit>({
    queryKey: getqueryKey(orgId),
    queryFn: () => fetchReleaseGroupLimit(orgId),
    staleTime: STALE_TIME,
  });
}
